import Swiper from 'swiper/bundle';

export function initLocationsSwipers(scope = document) {
  const swipers = Array.from(scope.querySelectorAll('.js-locations-swiper'));
  if (!swipers.length) return;

  swipers.forEach((el) => {
    if (el.__locationsSwiper) {
      try { el.__locationsSwiper.update(); } catch (_) {}
      return;
    }

    const section =
      el.closest('section[id^="locations-"]') ||
      el.closest('section') ||
      scope;

    const prevEl = section.querySelector('.locations-prev');
    const nextEl = section.querySelector('.locations-next');
    const pagEl  = section.querySelector('.locations-pagination');

    let opts = {};
    try {
      opts = JSON.parse(el.getAttribute('data-options') || '{}');
    } catch (e) {
      console.warn('[locations-swiper] JSON inválido em data-options', e);
    }

    const base = {
      loop: false,
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 16,
    };

    const options = {
      ...base,
      ...opts,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      pagination: pagEl ? { el: pagEl, clickable: true } : undefined,
    };

    const instance = new Swiper(el, options);
    el.__locationsSwiper = instance;

    const updateNavState = () => {
      if (!prevEl || !nextEl) return;
      const atStart = instance.isBeginning;
      const atEnd   = instance.isEnd;

      prevEl.classList.toggle('is-disabled', atStart);
      nextEl.classList.toggle('is-disabled', atEnd);

      prevEl.setAttribute('aria-disabled', String(atStart));
      nextEl.setAttribute('aria-disabled', String(atEnd));
    };

    instance.on('afterInit', updateNavState);
    instance.on('slideChange', updateNavState);
    instance.on('update', updateNavState);
    instance.on('resize', updateNavState);
    instance.on('reachBeginning', updateNavState);
    instance.on('reachEnd', updateNavState);

    setTimeout(() => {
      try { instance.update(); updateNavState(); } catch (_) {}
    }, 0);
  });
}
